import { render, staticRenderFns } from "./order-bol.vue?vue&type=template&id=04752862&"
import script from "./order-bol.vue?vue&type=script&lang=js&"
export * from "./order-bol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports